import { AHText, Box } from "arkh";
import React, { PropsWithChildren } from "react";
import { FormattedMessage } from "react-intl";

export function PLUScreenEmpty(props: {
  searching: boolean;
  selectedCategory?: { color: string; title: string };
  searchText: string;
}) {
  if (props.searching) {
    return (
      <PLUScreenEmptyContainer>
        <PLUScreenEmptySearching searchText={props.searchText} />
      </PLUScreenEmptyContainer>
    );
  }

  if (props.selectedCategory) {
    return (
      <PLUScreenEmptyContainer>
        <Box
          space="large"
          cornerRadius="medium"
          color="surface"
          style={{ flex: 1, maxWidth: 600 }}
        >
          <AHText
            type="title-small"
            style={{ textAlign: "center", alignSelf: "center" }}
            space="large"
          >
            <FormattedMessage
              defaultMessage="Category {categoryName} does not contain any products."
              description="PLUScreen empty text"
              values={{
                categoryName: (
                  <AHText
                    color={props.selectedCategory.color}
                    type="title-small"
                  >
                    {props.selectedCategory.title}
                  </AHText>
                ),
              }}
            />
          </AHText>
        </Box>
      </PLUScreenEmptyContainer>
    );
  }

  return null;
}

function PLUScreenEmptyContainer(props: PropsWithChildren<object>) {
  return (
    <Box
      spaceTop="xxlarge"
      spaceHorizontal="large"
      style={{
        alignItems: "center",
        flexDirection: "row",
        justifyContent: "center",
      }}
    >
      {props.children}
    </Box>
  );
}

function PLUScreenEmptySearching(props: { searchText: string }) {
  return (
    <Box
      space="large"
      cornerRadius="medium"
      color="surface"
      style={{ flex: 1, maxWidth: 600 }}
    >
      <AHText
        type="title-small"
        style={{ textAlign: "center", alignSelf: "center" }}
        space="large"
      >
        <FormattedMessage
          defaultMessage="Found no products matching search {searchText}"
          description="PLUScreenEmptySearching message"
          values={{
            searchText: (
              <AHText color="primary" type="title-small">
                {props.searchText}
              </AHText>
            ),
          }}
        />
      </AHText>
    </Box>
  );
}

export function PLUScreenStartSearch() {
  return (
    <PLUScreenEmptyContainer>
      <Box
        space="large"
        cornerRadius="medium"
        color="surface"
        style={{ flex: 1, maxWidth: 600 }}
      >
        <Box space="large">
          <AHText
            type="title-small"
            style={{ textAlign: "center", alignSelf: "center" }}
          >
            <FormattedMessage
              defaultMessage="Search among all products"
              description="PLUScreenStartSearch message"
            />
          </AHText>
          <AHText
            type="body"
            spaceTop="medium"
            style={{ textAlign: "center", alignSelf: "center" }}
          >
            <FormattedMessage
              defaultMessage="Search by name, or PLU. Results are shown from all categories."
              description="PLUScreenStartSearch detail message"
            />
          </AHText>
        </Box>
      </Box>
    </PLUScreenEmptyContainer>
  );
}
